<script setup>
import { useDisplay } from 'vuetify'
import { useCustomFieldRenderer } from '@/composables/useCustomFieldRenderer'
import CustomFieldDefaultType from '@/components/customFields/CustomFieldDefaultType.vue'

const { mobile } = useDisplay()

const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})

const customFieldRenderer = useCustomFieldRenderer(props.project, props.unit, props.fieldKey)

const {
    field,
    raw,
    typed,
    full,
    prefix,
    suffix,
    customRenderer,
    hideRenderer,
    hasPrefix,
    hasSuffix,
    hasCustomRenderer,
    hasHideRenderer,
    isHidden
} = customFieldRenderer

const size = computed(() => {
    return mobile ? 'small' : 'medium'
})
</script>
<template>
    <CustomFieldDefaultType :project="props.project" :unit="props.unit" :field-key="props.fieldKey">
        <template #hide="scope">
            <slot name="hide" v-bind="scope" />
        </template>
        <template #hidden="scope">
            <slot name="hidden" v-bind="scope" />
        </template>
        <template #prefix="scope">
            <slot name="prefix" v-bind="scope" />
        </template>
        <template #suffix="scope">
            <slot name="suffix" v-bind="scope" />
        </template>
        <template #default="scope">
            <slot v-bind="scope || {}">
                <v-icon
                    v-if="raw"
                    :size="size"
                    dense
                    color="success"
                    icon="mdi-check-bold"
                ></v-icon>
                <v-icon v-else icon="mdi-close-thick" :size="size" dense color="error"> </v-icon>
            </slot>
        </template>
    </CustomFieldDefaultType>
</template>
